/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import 'jrs-ui/src/util/webpackPublicPathSetup';
const importStartup = import('jrs-ui/src/util/mainPagesStartup')
const importMain = () => import('./dashboardViewerBare.common')
const importCommonModule = () => import('../commons/commons.main')

importStartup.then(({default: startup}) => startup({
    importCommonModule,
    bundles: [
        "jasperserver_config",
        "CommonBundle",
        "DashboardBundle",
        "RepositoryResourceBundle",
        "all",
        "jasperserver_messages",
        "InputControlsValidation",
        "ScalableInputControlsBundle",
        "AdHocBundle",
        "EmbedVizBundle"
    ],
    settings: [
        "treeComponent",
        "decimalFormatSymbols",
        "dateTimeSettings"
    ]
})).then(importMain)